export const DRAWER_WIDTH = '42rem';
export const PAGE_HEADER_HEIGHT = '7rem';
